import React from 'react';

const LoginFailedPage = (props: any) => {
    return (
        <div className="login-failed-page">
            <div className="login-failed-content">
                <img className="login-photo-1" src="https://khicindekocvar.blob.core.windows.net/cdn/prod/mobile-warning.svg" />

                <img className="login-photo-2" src="https://khicindekocvar.blob.core.windows.net/prod/logout2.png" />

                {props.message
                    ?

                    <p className="title" id="transition-login-description">{props.message}</p>
                    :
                    <p className="title" id="transition-login-description">
                        Koç Moments uygulaması ve yönetici arkadaşları arasında iletişimi sıcak tutmak amacıyla <br />
                        tasarlanmış olup uygulamaya sadece ekip yöneten çalışma arkadaşlarımız giriş yapabilmektedir. <br />
                        Uygulamaya giriş için yetkinin olmadığını görüyoruz. Ekip yönetiyorsan ve giriş yapamıyorsan <br />
                        cozum@kocweb.com mail adresi üzerinden çözüm merkezine ulaşabilirsin.
                    </p>
                }
            </div>
        </div>
    );
}

export default LoginFailedPage;
